import { useHttpClient } from '@/common/api/httpClient';
import type { ReportResponse } from '../models/ReportResponse';

export function useListReportApi() {
  return {
    execute,
  };

  async function execute() {
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('report'), {
      method: 'GET',
      headers,
    });

    const response = await httpClient.execute(request);
    if (response.ok) {
      const reports = (await response.json()) as ReportResponse[];

      return reports.filter((report) => report.enabled);
    }

    return [];
  }
}
